import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewChild,
    ViewChildren,
    QueryList,
    HostListener,
    Inject,
    LOCALE_ID,
} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

import { Program } from '../programs.models';
import { ProgramsResolve } from '../../programs/programs-resolve.service';
import { GncProgramsService } from '../../api/gnc-programs.service';
import { ModalFlowService } from './modalflow/modalflow.service';
import {
    ObservationFeature,
    ObservationPropertiesList,
    TaxonomyList,
} from './observation.model';
import { ObsMapComponent } from './map/map.component';
import { MediaGaleryComponent } from '../media-galery/media-galery.component';
import { ObsListComponent } from './list/list.component';
import { ModalFlowComponent } from './modalflow/modalflow.component';
import { ProgramBaseComponent } from '../base/program-base.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../auth/user-dashboard/user.service.service';
import { ObservationsService } from './observations.service';
import { ObservationFeatureCollection } from './observation.model';
import { MainConfig } from '../../../conf/main.config';

@Component({
    selector: 'app-observations',
    templateUrl: './obs.component.html',
    styleUrls: ['./obs.component.css', '../../home/home.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [ProgramsResolve],
})
export class ObsComponent extends ProgramBaseComponent implements OnInit {
    observations: ObservationFeatureCollection;
    observedSpeciesUniqueSorted: ObservationPropertiesList;
    surveySpecies: TaxonomyList;
    @ViewChild(ObsMapComponent, { static: true }) obsMap: ObsMapComponent;
    @ViewChild(ObsListComponent, { static: true }) obsList: ObsListComponent;
    @ViewChild(MediaGaleryComponent, { static: true })
    mediaGalery: MediaGaleryComponent;
    @ViewChildren(ModalFlowComponent) modalFlow: QueryList<ModalFlowComponent>;

    selectedObs: ObservationFeature;
    public isCollapsed = true;
    isMobile: boolean;
    hideProgramHeader = false;
    mediaPanel = false;
    obsToValidate: ObservationFeature;
    modalRef: NgbModalRef;
    role_id: number;
    isValidator = false;
    username: string = null;
    currentLanguage = 'pt-BR';

    exploreQuery = '';
    exploreLocation = '';
    exploreFamily = '';
    explorePeriod = 'all';
    explorePhoto = 'all';
    exploreFiltersOpen = false;
    exploreMapExpanded = false;
    exploreShowAllRecords = false;
    exploreLoading = true;
    exploreError = false;
    catalogLoading = true;
    catalogError = false;
    private pendingExploreFamily = '';
    private exploreMapCacheKey = '';
    private exploreMapCache: ObservationFeatureCollection = {
        type: 'FeatureCollection',
        features: [],
    };

    constructor(
        @Inject(LOCALE_ID) readonly localeId: string,
        private route: ActivatedRoute,
        private router: Router,
        private programService: GncProgramsService,
        public flowService: ModalFlowService,
        public breakpointObserver: BreakpointObserver,
        private titleService: Title,
        private metaTagService: Meta,
        public auth: AuthService,
        public userService: UserService,
        private modalService: NgbModal,
        private observationsService: ObservationsService
    ) {
        super();
        this.currentLanguage =
            localStorage.getItem('language') === 'fr' ? 'fr' : 'pt-BR';
        this.route.params.subscribe((params) => {
            this.program_id = params['id'];
            this.flowService.closeModal(); // Avoid keeping another program's form open
        });
        this.route.fragment.subscribe((fragment) => {
            this.fragment = fragment;
        });
        this.route.queryParams.subscribe((params) => {
            this.hideProgramHeader = 'hideProgramHeader' in params;

            const familyParam =
                typeof params['family'] === 'string'
                    ? params['family'].trim().slice(0, 80)
                    : '';

            this.pendingExploreFamily = familyParam;

            if (this.surveySpecies && this.surveySpecies.length) {
                this.exploreFamily =
                    this.exploreFamilies.indexOf(familyParam) >= 0
                        ? familyParam
                        : '';
            }
        });
    }

    t(portuguese: string, french: string): string {
        return this.currentLanguage === 'fr' ? french : portuguese;
    }

    ngOnInit(): void {
        this.breakpointObserver
            .observe(['(min-width: 700px)'])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.isMobile = false;
                } else {
                    this.isMobile = true;
                }
            });
        if (this.program_id) {
            this.route.data.subscribe((data: { programs: Program[] }) => {
                this.programs = data.programs;
                this.program = this.programs.find(
                    (p) => p.id_program == this.program_id
                );
                this.taxonomyListID = this.program.taxonomy_list;
                this.exploreLoading = true;
                this.exploreError = false;
                this.catalogLoading = true;
                this.catalogError = false;

                forkJoin([
                    this.programService.getProgramObservations(this.program_id),
                    this.programService.getProgram(this.program_id),
                ]).subscribe(
                    ([observations, program]) => {
                        this.observations = observations || {
                            type: 'FeatureCollection',
                            features: [],
                        };
                        this.observedSpeciesUniqueSorted =
                            this.getUniqueSortedSpecies(
                                this.observations.features || []
                            );
                        this.programFeature = program;
                        this.exploreLoading = false;
                    },
                    () => {
                        this.observations = {
                            type: 'FeatureCollection',
                            features: [],
                        };
                        this.exploreLoading = false;
                        this.exploreError = true;
                    }
                );

                this.programService
                    .getProgramTaxonomyList(this.taxonomyListID, { limit: 500 })
                    .subscribe(
                        (taxa: TaxonomyList) => {
                            this.surveySpecies = taxa || [];

                            this.exploreFamily =
                                this.pendingExploreFamily &&
                                this.exploreFamilies.indexOf(
                                    this.pendingExploreFamily
                                ) >= 0
                                    ? this.pendingExploreFamily
                                    : '';

                            this.catalogLoading = false;
                        },
                        () => {
                            this.surveySpecies = [];
                            this.catalogLoading = false;
                            this.catalogError = true;
                        }
                    );
                this.titleService.setTitle(
                    this.MainConfig.appName + ' - ' + this.program.title
                );
                this.metaTagService.updateTag({
                    name: 'description',
                    content: this.program.short_desc,
                });
                this.metaTagService.updateTag({
                    property: 'og:title',
                    content: MainConfig.appName + ' - ' + this.program.title,
                });
                this.metaTagService.updateTag({
                    property: 'og:description',
                    content: this.program.short_desc,
                });
                this.metaTagService.updateTag({
                    property: 'og:image',
                    content: this.program.image,
                });
                this.metaTagService.updateTag({
                    property: 'og:url',
                    content: MainConfig.URL_APPLICATION + this.router.url,
                });
                this.metaTagService.updateTag({
                    property: 'twitter:title',
                    content: MainConfig.appName + ' - ' + this.program.title,
                });
                this.metaTagService.updateTag({
                    property: 'twitter:description',
                    content: this.program.short_desc,
                });
                this.metaTagService.updateTag({
                    property: 'twitter:image',
                    content: this.program.image,
                });
            });
        }

        const access_token = localStorage.getItem('access_token');
        if (access_token) {
            this.auth.ensureAuthorized().subscribe((user) => {
                if (user && user['features'] && user['features']['id_role']) {
                    this.isValidator = user['features']['validator'];
                }
            });
        }
        this.username = localStorage.getItem('username');
    }

    @HostListener('document:NewObservationEvent', ['$event'])
    newObservationEventHandler(e: CustomEvent): void {
        e.stopPropagation();

        this.observations.features.unshift(e.detail);
        this.observations = {
            type: 'FeatureCollection',
            features: this.observations.features,
        };
        this.updateObservedSpecies();
    }

    private updateObservedSpecies(): void {
        this.observedSpeciesUniqueSorted = this.getUniqueSortedSpecies(
            this.observations.features
        );
    }

    addObsClicked(): void {
        this.modalFlow.first.clicked();
    }

    openValidateModal(validateModal: NgbModalRef, idObs: number): void {
        this.obsToValidate = this.observations.features.find(
            (obs) => obs.properties.id_observation === idObs
        );
        if (this.canValidateObservation()) {
            this.modalRef = this.modalService.open(validateModal, {
                size: 'lg',
                windowClass: 'obs-modal',
                centered: true,
            });
        }
    }

    canValidateObservation(): boolean {
        return (
            this.MainConfig.VERIFY_OBSERVATIONS_ENABLED &&
            this.isValidator &&
            this.obsToValidate.properties.validation_status != 'VALIDATED' &&
            (!this.obsToValidate.properties.observer ||
                (this.obsToValidate.properties.observer &&
                    typeof this.obsToValidate.properties.observer !==
                    'string' &&
                    this.obsToValidate.properties.observer.username !==
                    this.username))
        );
    }

    closeModal(observationId: number = null): void {
        if (observationId) {
            this.route.data.subscribe(() => {
                this.observationsService
                    .getObservation(observationId)
                    .subscribe((updatedObservation: ObservationFeature) => {
                        this.observations.features[
                            this.observations.features.findIndex(
                                (obs) =>
                                    obs.properties.id_observation ===
                                    observationId
                            )
                        ] = updatedObservation;
                    });
            });
        }
        this.modalRef.close();
    }

    private getUniqueSortedSpecies(features: any[]): ObservationPropertiesList {
        const uniqueSpecies = features
            .map((feature) => feature.properties)
            .filter(
                (property, index, self) =>
                    self.findIndex((p) => p.cd_nom === property.cd_nom) ===
                    index
            );

        uniqueSpecies.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
        return uniqueSpecies;
    }


    get exploreLocations(): string[] {
        const values = (this.observations && this.observations.features
            ? this.observations.features
            : []
        )
            .map((observation) =>
                observation && observation.properties
                    ? observation.properties.municipality
                    : null
            )
            .filter((value) => !!value);

        return Array.from(new Set(values as string[])).sort((a, b) =>
            a.localeCompare(b, 'pt-BR')
        );
    }

    get exploreFamilies(): string[] {
        const values = (this.surveySpecies || [])
            .map((item) =>
                item && item.taxref ? item.taxref.famille : null
            )
            .filter((value) => !!value);

        return Array.from(new Set(values as string[])).sort((a, b) =>
            a.localeCompare(b, 'pt-BR')
        );
    }

    get filteredExploreObservations(): ObservationFeature[] {
        const query = this.normalizeExplore(this.exploreQuery);
        const now = new Date().getTime();
        const periodDays =
            this.explorePeriod === '30'
                ? 30
                : this.explorePeriod === '90'
                ? 90
                : this.explorePeriod === '365'
                ? 365
                : 0;

        return (this.observations && this.observations.features
            ? this.observations.features
            : []
        )
            .filter((observation) => {
                if (!observation || !observation.properties) {
                    return false;
                }

                const properties = observation.properties;
                const family = this.getObservationFamily(observation);
                const hasPhoto = !!this.getExploreObservationPhoto(observation);

                if (
                    this.exploreLocation &&
                    properties.municipality !== this.exploreLocation
                ) {
                    return false;
                }

                if (this.exploreFamily && family !== this.exploreFamily) {
                    return false;
                }

                if (this.explorePhoto === 'with' && !hasPhoto) {
                    return false;
                }

                if (this.explorePhoto === 'without' && hasPhoto) {
                    return false;
                }

                if (periodDays) {
                    const dateValue = new Date(properties.date as any).getTime();
                    if (
                        !dateValue ||
                        now - dateValue > periodDays * 24 * 60 * 60 * 1000
                    ) {
                        return false;
                    }
                }

                if (query) {
                    const haystack = [
                        this.getExploreCommonName(observation),
                        this.getExploreScientificName(observation),
                        properties.municipality,
                        this.getExploreObserver(observation),
                        family,
                    ]
                        .map((value) => this.normalizeExplore(value))
                        .join(' ');

                    if (haystack.indexOf(query) === -1) {
                        return false;
                    }
                }

                return true;
            })
            .sort((a, b) => {
                const dateA = new Date(a.properties.date as any).getTime() || 0;
                const dateB = new Date(b.properties.date as any).getTime() || 0;
                return dateB - dateA;
            });
    }

    get filteredExploreCollection(): ObservationFeatureCollection {
        const observationsLength =
            this.observations && this.observations.features
                ? this.observations.features.length
                : 0;
        const cacheKey = [
            this.exploreQuery,
            this.exploreLocation,
            this.exploreFamily,
            this.explorePeriod,
            this.explorePhoto,
            observationsLength,
        ].join('|');

        if (cacheKey !== this.exploreMapCacheKey) {
            this.exploreMapCacheKey = cacheKey;
            this.exploreMapCache = {
                type: 'FeatureCollection',
                features: this.filteredExploreObservations,
            };
        }

        return this.exploreMapCache;
    }

    get recentExploreObservations(): ObservationFeature[] {
        return this.filteredExploreObservations.slice(
            0,
            this.exploreShowAllRecords ? 12 : 3
        );
    }

    get filteredExploreTaxa(): TaxonomyList {
        const query = this.normalizeExplore(this.exploreQuery);
        const observationScoped =
            !!this.exploreLocation ||
            !!this.exploreFamily ||
            this.explorePeriod !== 'all' ||
            this.explorePhoto !== 'all';

        const observedCdNom = new Set(
            this.filteredExploreObservations.map(
                (observation) => observation.properties.cd_nom
            )
        );

        return (this.surveySpecies || []).filter((item) => {
            if (!item || !item.taxref) {
                return false;
            }

            if (
                this.exploreFamily &&
                item.taxref.famille !== this.exploreFamily
            ) {
                return false;
            }

            if (observationScoped && !observedCdNom.has(item.taxref.cd_nom)) {
                return false;
            }

            if (!query) {
                return true;
            }

            const directMatch = [
                item.taxref.nom_vern,
                item.taxref.lb_nom,
                item.taxref.nom_complet,
                item.taxref.famille,
            ]
                .map((value) => this.normalizeExplore(value))
                .join(' ')
                .indexOf(query) !== -1;

            return directMatch || observedCdNom.has(item.taxref.cd_nom);
        });
    }

    get exploreCatalogPreview(): TaxonomyList {
        return this.filteredExploreTaxa.slice(0, 5);
    }

    get hasExploreFilters(): boolean {
        return (
            !!this.exploreQuery ||
            !!this.exploreLocation ||
            !!this.exploreFamily ||
            this.explorePeriod !== 'all' ||
            this.explorePhoto !== 'all'
        );
    }

    clearExploreFilters(): void {
        this.exploreQuery = '';
        this.exploreLocation = '';
        this.exploreFamily = '';
        this.explorePeriod = 'all';
        this.explorePhoto = 'all';
    }

    toggleExploreFilters(): void {
        this.exploreFiltersOpen = !this.exploreFiltersOpen;
    }

    toggleExploreMap(): void {
        this.exploreMapExpanded = !this.exploreMapExpanded;
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    }

    openExploreObservation(observation: ObservationFeature): void {
        if (!observation || !observation.properties) {
            return;
        }

        this.router.navigate([
            '/programs',
            observation.properties.id_program || this.program_id,
            'observations',
            observation.properties.id_observation,
        ]);
    }

    openExploreTaxon(item: any): void {
        if (item && item.taxref) {
            this.router.navigate([
                '/synthesis/species',
                item.taxref.cd_nom,
            ]);
        }
    }

    getExploreCommonName(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return this.t('Espécie não identificada', 'Espèce non identifiée');
        }

        const p: any = observation.properties;
        return (
            p.common_name ||
            (p.taxref && p.taxref.nom_vern) ||
            p.name ||
            p.obs_txt ||
            this.t('Espécie não identificada', 'Espèce non identifiée')
        );
    }

    getExploreScientificName(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return '';
        }

        const p: any = observation.properties;
        return (
            p.sci_name ||
            (p.taxref && p.taxref.lb_nom) ||
            ''
        );
    }

    getExploreLocation(observation: ObservationFeature): string {
        if (
            observation &&
            observation.properties &&
            observation.properties.municipality
        ) {
            return observation.properties.municipality;
        }

        return this.t(
            'Localização não informada',
            'Localisation non renseignée'
        );
    }

    getExploreObserver(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return this.t('Anônimo', 'Anonyme');
        }

        const observer: any = observation.properties.observer;
        if (typeof observer === 'string') {
            return observer;
        }

        if (observer && observer.username) {
            return observer.username;
        }

        return this.t('Anônimo', 'Anonyme');
    }

    getExploreObservationPhoto(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return null;
        }

        const p: any = observation.properties;
        if (p.photos && p.photos.length && p.photos[0].url) {
            const url = p.photos[0].url;
            return /^https?:\/\//.test(url)
                ? url
                : MainConfig.API_ENDPOINT + url;
        }

        if (p.medias && p.medias.length && p.medias[0].id_media) {
            return (
                MainConfig.API_ENDPOINT +
                '/tmedias/thumbnail/' +
                p.medias[0].id_media +
                '?h=600'
            );
        }

        return null;
    }

    getExploreTaxonPhoto(item: any): string {
        if (!item || !item.taxref) {
            return null;
        }

        if (item.medias && item.medias.length && item.medias[0].id_media) {
            return (
                MainConfig.API_ENDPOINT +
                '/tmedias/thumbnail/' +
                item.medias[0].id_media +
                '?h=180'
            );
        }

        const observation = (this.observations && this.observations.features
            ? this.observations.features
            : []
        ).find(
            (feature) =>
                feature.properties &&
                feature.properties.cd_nom === item.taxref.cd_nom &&
                !!this.getExploreObservationPhoto(feature)
        );

        return observation
            ? this.getExploreObservationPhoto(observation)
            : null;
    }

    getExploreTaxonObservationCount(item: any): number {
        if (!item || !item.taxref) {
            return 0;
        }

        return (this.observations && this.observations.features
            ? this.observations.features
            : []
        ).filter(
            (feature) =>
                feature.properties &&
                feature.properties.cd_nom === item.taxref.cd_nom
        ).length;
    }

    getExploreTaxonPhotoCount(item: any): number {
        if (!item || !item.taxref) {
            return 0;
        }

        const taxonomyMediaCount =
            item.medias && item.medias.length ? item.medias.length : 0;

        return taxonomyMediaCount + (this.observations && this.observations.features
            ? this.observations.features
            : []
        ).reduce((total, feature) => {
            if (
                !feature.properties ||
                feature.properties.cd_nom !== item.taxref.cd_nom
            ) {
                return total;
            }

            const p: any = feature.properties;
            const photoCount = p.photos && p.photos.length ? p.photos.length : 0;
            return total + photoCount;
        }, 0);
    }

    getObservationFamily(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return '';
        }

        const item = (this.surveySpecies || []).find(
            (taxon) =>
                taxon &&
                taxon.taxref &&
                taxon.taxref.cd_nom === observation.properties.cd_nom
        );

        return item && item.taxref && item.taxref.famille
            ? item.taxref.famille
            : '';
    }

    private normalizeExplore(value: any): string {
        if (value === null || value === undefined) {
            return '';
        }

        return String(value)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    ngOnDestroy(): void {
        if (this.modalRef) this.modalRef.close();
    }
}
